import { useEffect, useState } from "react";
import { Button, Checkbox, Select, Space, Tree, message } from "antd";
import PageTitle from "../../components/PageTitle";
import {
  getAdminRoleMenuOptions,
  getAdminRoles,
  updateAdminRolePermissions,
} from "../../api";

function buildTreeData(options) {
  return (options || []).map((node) => ({
    key: node.key,
    title: node.label,
    children: node.children ? buildTreeData(node.children) : undefined,
  }));
}

function collectAllKeys(options, out = []) {
  (options || []).forEach((node) => {
    out.push(node.key);
    if (node.children) collectAllKeys(node.children, out);
  });
  return out;
}

const RolePermissions = () => {
  const [roles, setRoles] = useState([]);
  const [roleId, setRoleId] = useState(null);
  const [treeData, setTreeData] = useState([]);
  const [checked, setChecked] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const [rolesRes, optRes] = await Promise.all([
        getAdminRoles(),
        getAdminRoleMenuOptions(),
      ]);
      if (rolesRes?.success) {
        const list = rolesRes.data || [];
        setRoles(list);
        if (list.length > 0) setRoleId(list[0].id);
      }
      if (optRes?.success) setTreeData(buildTreeData(optRes.data || []));
    })();
  }, []);

  useEffect(() => {
    if (!roleId) return;
    const role = roles.find((r) => r.id === roleId);
    setChecked(Array.isArray(role?.permissions) ? role.permissions : []);
  }, [roleId, roles]);

  const handleSave = async () => {
    if (!roleId) return;
    setLoading(true);
    try {
      const res = await updateAdminRolePermissions(roleId, checked);
      if (!res?.success) throw new Error(res?.error);
      message.success("权限已保存");
      const rolesRes = await getAdminRoles();
      if (rolesRes?.success) setRoles(rolesRes.data || []);
    } catch (e) {
      message.error(e?.message || "保存失败");
    } finally {
      setLoading(false);
    }
  };

  const allKeys = collectAllKeys(treeData);

  return (
    <div>
      <PageTitle title="角色权限" />
      <Space style={{ marginBottom: 12 }}>
        <Select
          style={{ width: 200 }}
          placeholder="选择角色"
          value={roleId}
          onChange={setRoleId}
          options={roles.map((r) => ({ label: r.name, value: r.id }))}
        />
        <Button type="primary" loading={loading} disabled={!roleId} onClick={handleSave}>
          保存权限
        </Button>
        <Checkbox
          indeterminate={checked.length > 0 && checked.length < allKeys.length}
          checked={allKeys.length > 0 && checked.length === allKeys.length}
          onChange={(e) => setChecked(e.target.checked ? [...allKeys] : [])}
        >
          全选
        </Checkbox>
      </Space>
      <Tree
        checkable
        selectable={false}
        treeData={treeData}
        checkedKeys={checked}
        onCheck={(keys) => {
          const list = Array.isArray(keys) ? keys : keys.checked;
          setChecked(list);
        }}
      />
    </div>
  );
};

export default RolePermissions;
